import { render } from "./BillingUpdate.vue?vue&type=template&id=f7c76a72"
import script from "./BillingUpdate.vue?vue&type=script&lang=js"
export * from "./BillingUpdate.vue?vue&type=script&lang=js"

import "./BillingUpdate.vue?vue&type=style&index=0&id=f7c76a72&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__